import useModal from 'hook/useModal'
import { Heading, IconButton } from 'components'
export default function Frame({ url = '', title = '' }) {
  const { closeModal } = useModal()

  return (
    <section className={`popup-wrap  show`}>
      <section className={`popup-window`} style={{ height: '100%' }}>
        <section className="body">
          <header className={`site-header site-header-detail `}>
            <div className="row relative">
              <div className="left"></div>
              <Heading level="1" className="f-20 f-bold" text={title} />
              <div className="right">
                <IconButton size="40" type="close" onClick={() => closeModal()} />
              </div>
            </div>
          </header>
          <iframe src={url} title="팝업" style={{ height: '100%' }} />
        </section>
      </section>
    </section>
  )
}
